import { render, staticRenderFns } from "./GoogleAddress.vue?vue&type=template&id=36964e20"
import script from "./GoogleAddress.vue?vue&type=script&lang=js"
export * from "./GoogleAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports